module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 1-a3c9ab7d3367c8774b56a3ea9d9b971a.jpg";